import React, { useMemo } from "react";
import { createEmptyProjectPart } from "./factories";
import PartCard from "./PartCard";
import Button from "../../../../../../components/elements/Button";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function PartsEditor({ project, path, updateAtPath }) {
    const parts = project?.parts || [];

    const canDeletePart = (partIndex) => {
        // Schema likely requires minItems: 1.
        return parts.length > 1;
    };

    const addPart = () => {
        const next = parts.concat([createEmptyProjectPart()]);
        updateAtPath([...path, "parts"], next);
    };

    const deletePart = (partIndex) => {
        if (!canDeletePart(partIndex)) {
            window.alert("You must have at least one part.");
            return;
        }
        const next = parts.filter((_, i) => i !== partIndex);
        updateAtPath([...path, "parts"], next);
    };

    const partsPath = useMemo(() => [...path, "parts"], [path]);

    return (
        <div style={{ display: "grid", gap: 12 }}>
            <div className='flex gap-8'>
                <h2>بخش‌ها</h2>
                <Button className='w-fit' onClick={addPart}>
                    <FontAwesomeIcon icon={faPlus} size={'lg'} />
                </Button>
            </div>

            {parts.map((part, partIndex) => (
                <PartCard
                    key={part.id || partIndex}
                    part={part}
                    path={[...partsPath, partIndex]}
                    updateAtPath={updateAtPath}
                    onDelete={() => deletePart(partIndex)}
                    canDelete={canDeletePart(partIndex)}
                />
            ))}
        </div>
    );
}
